import {
  FormField,
  Input,
  ColumnLayout,
  Grid,
  Spinner,
  Badge,
} from '@amzn/awsui-components-console';
import { useEffect, useState } from 'react';
import { LaunchTask } from '@amzn/awsdev-docs-virtual-smiley-conference-typescript-client';

interface BuddyLaunchProps {
  buddyLaunch: LaunchTask;
  onDeleted?: () => void;
  LaunchTaskDetail: LaunchTask;
}

type BuddyLaunchesProps = {
  buddyLaunches: LaunchTask[];
  onCountChange?: (count: number) => void;
  launchTaskDetail: LaunchTask;
  buddyLaunchesLoading: boolean;
  buddyLaunchFetchSuccess: boolean;
};

const BuddyLaunch = ({ LaunchTaskDetail, buddyLaunch }: BuddyLaunchProps) => {
  const [newbuddyLaunch, setNewBuddyLaunch] = useState(buddyLaunch);

  useEffect(() => {
    setNewBuddyLaunch(buddyLaunch);
  }, [buddyLaunch]);

  return (
    <div>
      <ColumnLayout columns={3}>
        <div>
          <FormField
            // description='Buddy launch ticket ID.'
            label='Buddy launch ID'
          >
            <Input disabled={true} value={newbuddyLaunch.launchId} />
          </FormField>
        </div>
        <div>
          <FormField
            // description='Service name of your buddy launch.'
            label='Buddy launch name'
          >
            <Input disabled={true} value={newbuddyLaunch.name ?? ''} />
          </FormField>
        </div>
        <div>
          <FormField
            // description='Writer assigned to this launch.'
            label='Assignee'
          >
            <Input
              disabled={true}
              value={newbuddyLaunch?.writerAssignment?.alias ?? ''}
            />
          </FormField>
        </div>
      </ColumnLayout>
    </div>
  );
};

export const BuddyLaunches = ({
  buddyLaunches,
  launchTaskDetail,
  buddyLaunchesLoading,
  buddyLaunchFetchSuccess,
}: BuddyLaunchesProps) => {
  const [launches, setLaunches] = useState(buddyLaunches);

  function removeDuplicates(arr: LaunchTask[]) {
    const uniqueTasks = new Map<string, LaunchTask>();
    arr.forEach((task) => {
      uniqueTasks.set(task.launchId, task);
    });
    return Array.from(uniqueTasks.values());
  }

  useEffect(() => {
    setLaunches(removeDuplicates(buddyLaunches));
  }, [buddyLaunches]);

  if (buddyLaunchesLoading) {
    return <Spinner size='large' />;
  }

  if (!buddyLaunchFetchSuccess) {
    return <Badge color='red'>Error</Badge>;
  }

  return (
    <div>
      {launches.map((buddyLaunch, i) => (
        <BuddyLaunch
          key={i}
          LaunchTaskDetail={launchTaskDetail}
          buddyLaunch={buddyLaunch}
        />
      ))}
    </div>
  );
};

export default BuddyLaunches;
